module.exports = __webpack_public_path__ + "assets/img/5w.ed76bf18.png";